<template>
  <div class="trace-container">
    <div class="trace-header">
      <div class="header-content">
        <button @click.stop="goBack" class="back-button">
          <span class="back-icon">←</span>
          <span>返回</span>
        </button>
        <div class="header-title">
          <div class="title-icon">🔎</div>
          <h1>视频溯源</h1>
        </div>
      </div>
    </div>

    <div class="trace-content">
      <div class="trace-main-grid">
        <div class="left-panel">
          <div class="current-shop-section" v-if="advertiserName">
            <div class="shop-info-container">
              <div class="shop-icon">🏪</div>
              <div class="shop-details">
                <h3 class="shop-name">当前授权店铺</h3>
                <p class="shop-advertiser">{{ advertiserName }}</p>
              </div>
            </div>
          </div>

          <div class="form-card">
            <h2 class="form-title">查询条件</h2>
            <div class="form-grid">
              <div class="input-group full-width">
                <label for="trace-material-id">素材ID</label>
                <input
                  id="trace-material-id"
                  v-model.trim="materialId"
                  type="text"
                  placeholder="请输入素材ID"
                />
              </div>
            </div>

            <div class="action-row">
              <button class="query-button" type="button" :disabled="querying" @click="queryMaterial">
                {{ querying ? '查询中...' : '查询' }}
              </button>
            </div>
          </div>

          <div v-if="statusMessage" class="status-message" :class="{ error: statusType === 'error', success: statusType === 'success' }">
            {{ statusMessage }}
          </div>
        </div>

        <div class="right-panel">
          <div class="result-card">
            <h2 class="form-title">查询结果</h2>
            <div class="result-empty" v-if="resultList.length === 0">请先选择条件并查询</div>
            <div class="result-list" v-else>
              <div class="result-item" v-for="(item, index) in resultList" :key="`${item.id || item.material_id || index}`">
                <div class="result-filename">标题：{{ item.filename || '-' }}</div>
                <video
                  v-if="item.url"
                  class="result-video"
                  :src="item.url"
                  controls
                  preload="metadata"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import API_CONFIG from '@/api/config'
import { createAdaptiveViewportMixin } from '@/mixins/adaptiveViewport'

export default {
  name: 'VideoTrace',
  mixins: [createAdaptiveViewportMixin({ designWidth: 1440, designHeight: 900, minScale: 0.56 })],
  data() {
    return {
      accessToken: '',
      advertiserName: '',
      username: '',
      materialId: '',
      querying: false,
      resultList: [],
      statusMessage: '',
      statusType: ''
    }
  },
  async created() {
    const query = this.$route.query || {}
    this.accessToken = query.accessToken || localStorage.getItem('accessToken') || ''
    this.advertiserName = query.advertiserName || localStorage.getItem('advertiserName') || ''
    this.username = query.username || localStorage.getItem('username') || ''
  },
  methods: {
    toSafeHeaderValue(value) {
      const str = String(value ?? '')
      for (let i = 0; i < str.length; i += 1) {
        if (str.charCodeAt(i) > 255) {
          return encodeURIComponent(str)
        }
      }
      return str
    },
    goBack() {
      this.$router.push('/home')
    },
    async queryMaterial() {
      this.statusMessage = ''
      this.statusType = ''
      this.resultList = []

      if (!this.materialId) {
        this.statusType = 'error'
        this.statusMessage = '请输入素材ID'
        return
      }

      this.querying = true
      try {
        const response = await axios.post(
          API_CONFIG.videoMaterialId(),
          {
            materialId: this.materialId
          },
          {
            headers: {
              'Content-Type': 'application/json',
              username: this.toSafeHeaderValue(this.username || '')
            }
          }
        )
        const data = response.data || {}
        if (Number(data.code) === 200) {
          const payload = data.data || data.result || data
          const list = payload.list || []
          this.resultList = list
          this.statusType = 'success'
          this.statusMessage = list.length > 0 ? `查询成功，共 ${list.length} 条` : '查询成功，暂无数据'
        } else {
          this.statusType = 'error'
          this.statusMessage = data.msg || data.message || '查询失败'
        }
      } catch (error) {
        this.statusType = 'error'
        this.statusMessage = error.response?.data?.msg || error.response?.data?.message || '查询失败'
      } finally {
        this.querying = false
      }
    }
  }
}
</script>

<style scoped>
.trace-container {
  min-height: 100vh;
  height: 100vh;
  background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.trace-header {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  padding: 14px 0;
}

.header-content {
  width: min(calc(100% - 32px), 1200px);
  margin: 0 auto;
  padding: 0;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: 20px;
}

.back-button {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 25px;
  padding: 10px 20px;
  color: white;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
}

.header-title {
  display: flex;
  align-items: center;
  gap: 10px;
}

.title-icon {
  font-size: 24px;
}

.header-title h1 {
  color: white;
  font-size: 24px;
  font-weight: 600;
  margin: 0;
}

.trace-content {
  flex: 1;
  width: min(calc(100% - 32px), 1200px);
  margin: 0 auto;
  padding: 16px 0 18px;
  overflow: hidden;
  min-height: 0;
  box-sizing: border-box;
}

.trace-main-grid {
  display: grid;
  grid-template-columns: 420px 1fr;
  gap: 16px;
  align-items: start;
}

.left-panel,
.right-panel {
  min-width: 0;
}

.current-shop-section {
  margin-bottom: 12px;
}

.shop-info-container {
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  padding: 16px 18px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.shop-name {
  color: rgba(255, 255, 255, 0.8);
  font-size: 14px;
  margin: 0;
}

.shop-advertiser {
  color: white;
  font-size: 16px;
  margin: 0;
}

.form-card,
.result-card {
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 15px;
  padding: 20px;
  margin-bottom: 16px;
}

.form-title {
  color: #fff;
  margin: 0 0 14px;
  font-size: 18px;
}

.form-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 14px;
}

.full-width {
  grid-column: 1 / -1;
}

.input-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.input-group label {
  color: rgba(255, 255, 255, 0.86);
  font-size: 13px;
}

.input-group input {
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 8px;
  color: white;
  font-size: 14px;
  padding: 10px 12px;
}

.action-row {
  margin-top: 14px;
}

.query-button {
  border: none;
  border-radius: 999px;
  background: linear-gradient(45deg, #26c6da, #00acc1);
  color: #fff;
  padding: 10px 22px;
  font-size: 14px;
  cursor: pointer;
}

.query-button:disabled {
  opacity: 0.8;
  cursor: not-allowed;
}

.status-message {
  border-radius: 10px;
  padding: 10px 12px;
  margin-bottom: 14px;
  font-size: 13px;
}

.status-message.success {
  background: rgba(46, 213, 115, 0.2);
  border: 1px solid rgba(46, 213, 115, 0.4);
  color: #7dffb8;
}

.status-message.error {
  background: rgba(255, 107, 107, 0.2);
  border: 1px solid rgba(255, 107, 107, 0.4);
  color: #ff9f9f;
}

.result-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.result-empty {
  color: rgba(255, 255, 255, 0.75);
  font-size: 14px;
}

.result-item {
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.06);
  padding: 10px 12px;
}

.result-filename {
  color: #fff;
  font-weight: 600;
  margin-bottom: 8px;
  word-break: break-all;
}

.result-video {
  width: 100%;
  max-height: 460px;
  border-radius: 8px;
  background: #000;
  margin-bottom: 8px;
}

@media (max-width: 768px) {
  .trace-main-grid {
    grid-template-columns: 1fr;
  }
}
</style>
